import Vue from "vue";

const BASKET_PREVIEW_COMPONENT_NAME = "basket-preview";

Vue.directive("toggle-basket-preview", {
  bind(el) {
    el.addEventListener("click", (event) => {
      const isOpen = document.body.classList.contains("basket-open");
      const badge = document.querySelector("div[id^=trustbadge]");

      let timeout = 0;

      // trigger the lazyloading of the basket-preview
      if (
        !vueApp.$store.state.lazyComponent.components.hasOwnProperty(
          BASKET_PREVIEW_COMPONENT_NAME
        )
      ) {
        vueApp.$store.dispatch("loadComponent", BASKET_PREVIEW_COMPONENT_NAME);
        timeout = 100;
      }

      // postpone the opening for 100ms, to prevent markup jumps
      setTimeout(() => {
        document.body.classList.toggle("basket-open");

        if (badge) {
          badge.style.display = isOpen ? "block" : "none";
        }
      }, timeout);

      event.preventDefault();
      event.stopPropagation();
    });
  },
});
